// **********************************************************
// Brands Slider Card
// **********************************************************

const brandsSliderCard = document.querySelectorAll('[data-slider="brands-slider-card"]');

const brandsSliderCardOptions = {
  slidesPerView: 'auto',
  spaceBetween: 48,
  watchOverflow: true,
  centeredSlides: true,
  centerInsufficientSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

brandsSliderCard.forEach((el) => {
  const parentElem = el.closest('.brands-slider-card');
  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  brandsSliderCardOptions.navigation.prevEl = arrowLeft;
  brandsSliderCardOptions.navigation.nextEl = arrowRight;

  setTimeout(() => {
    new Swiper(el, brandsSliderCardOptions);
  }, 300);
});
